<template>
  <div class="banner-decor" aria-hidden="true" />
</template>

<style scoped lang="scss">
.banner-decor {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: url('~/assets/images/profile-banner.svg');
  background-size: auto 100%;
  background-repeat: no-repeat;
}
</style>
